import Alert from '@/models/alert';
import axios from 'axios';

let pagination = {
    start: 0,
    limit: 25,
    count: 0,
    unread: 0
}

export class AlertsController {
    /**
     * Get the available list of alerts
     *
     * @param {Number} start - Required starting index for pagination
     * @param {Number} limit - Optional limit per page (default: 25)
     * @returns {Object|Error} An object with data array and pagination metadata or an error object
     */
    static async index(start, limit = pagination.limit) {
        const query = `?start=${start}&limit=${limit}`;

        let response = axios
            .get(`alerts${query}`)
            .then((resp) => {
                // Handle both old array format and new paginated format
                if (Array.isArray(resp.data)) {
                    return {
                        data: resp.data.map((alert) => new Alert(alert)),
                        pagination
                    };
                }
                return {
                    data: (resp.data.data ?? []).map((alert) => new Alert(alert)),
                    pagination: resp.data.pagination ?? pagination,
                };
            })
            .catch((error) => Promise.reject(error))
        return await response
    }

    /**
     * Mark as read
     *
     * @param {Int} $alert id fron the alert
     * @returns {Alert|Error} An alert model or an error object
     */
    static async update($alert) {
        let response = axios
            .patch(`alerts/${$alert.id}`, $alert)
            .then((resp) => new Alert(resp))
            .catch((error) => Promise.reject(error))
        return await response
    }

    /**
     * Mark all as read
     *
     * @param void
     * @returns {Array|Error} An array of alert models or an error object
     */
    static async bulkUpdate() {
        let response = axios
            .patch('alerts/mark-all-read')
            .then((resp) => resp.data.map((alert) => new Alert(alert)))
            .catch((error) => Promise.reject(error))
        return await response
    }

}